import "@arco-design/web-react/es/Button/style";
import _Button from "@arco-design/web-react/es/Button";
import _IconRefresh from "@arco-design/web-react/icon/react-icon/IconRefresh";

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
export function ButtonRefresh(props) {
  return /*#__PURE__*/React.createElement(_Button, _extends({
    icon: /*#__PURE__*/React.createElement(_IconRefresh, null)
  }, props), "\u5237\u65B0");
}